import {
  Avatar,
  Box,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { FC, useCallback, useContext } from "react";
import { FaSignOutAlt, FaUser } from "react-icons/fa";

import { TenantContext } from "@nens/ranalib";

import { useUser } from "../providers/AuthProvider";

const UserMenu: FC = () => {
  const user = useUser();
  const tenantContext = useContext(TenantContext);

  // The logOut property only exists if the authentication situation is not public.
  // In this app, that is never the case.
  const logOut = tenantContext.isPublic ? () => null : tenantContext.logOut;

  const { isOpen, onOpen, onClose } = useDisclosure();

  const toggle = useCallback(() => (isOpen ? onClose() : onOpen()), [isOpen, onOpen, onClose]);

  const userName = user.firstName || user.lastName || user.username || "" + user.id || "User";
  const getInitials = () => {
    if (user.firstName && user.lastName) {
      return `${user.firstName[0]}${user.lastName[0]}`;
    }

    return "";
  };

  const userInitials = getInitials();

  return (
    <Menu isOpen={isOpen}>
      <MenuButton
        onClick={toggle}
        background="none"
        color="inherit"
        border="none"
        padding={0}
        maxWidth="250px"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
        fontSize="1.25em"
      >
        <Box display="flex" alignItems="center">
          <Avatar
            title={userName}
            fontSize={15}
            bg="brand.glacier"
            color="brand.sky"
            border="2px solid"
            overflow="hidden"
            position="relative"
            icon={
              userInitials.length > 0 ? (
                <Box color="brand.analytic">{getInitials()}</Box>
              ) : (
                <Icon as={FaUser} boxSize="45px" color="brand.keep_analytic" />
              )
            }
          />
          <Box pl="10px">
            {user.firstName || user.lastName || user.username || "" + user.id || "User"}
          </Box>
        </Box>
      </MenuButton>
      <MenuList>
        <MenuItem
          color="black"
          bg="brand.grey.100"
          border="none"
          icon={<Icon as={FaSignOutAlt} />}
          onClick={logOut}
          _hover={{ bg: "brand.analytic", color: "white" }}
        >
          Sign out
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default UserMenu;
